import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers';
import { RoleAuthGuard } from "./shared/auth/guard/role.auth-guard";
import {AuthGuard} from "@auth0/auth0-angular";

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard, RoleAuthGuard],
    data: { roles: ['user', 'billing'] },
    children: [
      {
        path: '',
        redirectTo: 'user/clients',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/user/user-dashboard.module').then(m => m.UserDashboardModule),
      },
      {
        path: 'user/clients',
        loadChildren: () =>
          import('./modules/user/clients/user-clients.module').then(m => m.UserClientsModule),
      },
      {
        path: 'tutorials',
        loadChildren: () =>
          import('./modules/shared/tutorials/tutorials.module').then(m => m.TutorialsModule),
      },
    ]

  },
  {
    path: 'admin',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard, RoleAuthGuard],
    data: { roles: ['admin'] },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/admin/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'connectors',
        loadChildren: () =>
          import('./modules/admin/connectors/connectors.module').then(m => m.ConnectorsModule),
      },
      {
        path: 'contracts',
        loadChildren: () =>
          import('./modules/admin/contracts/contracts.module').then(m => m.ContractsModule),
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('./modules/admin/clients/clients.module').then(m => m.ClientsModule),
      },
      {
        path: 'technicians',
        loadChildren: () =>
          import('./modules/admin/technicians/technicians.module').then(m => m.TechniciansModule),
      },
      {
        path: 'cities',
        loadChildren: () =>
          import('./modules/admin/cities/cities.module').then(m => m.CitiesModule),
      },
      {
        path: 'tutorials',
        loadChildren: () =>
          import('./modules/shared/tutorials/tutorials.module').then(m => m.TutorialsModule),
      },
    ],
  },

  { path: '**', redirectTo: 'admin/dashboard' },
];
